import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import type { State } from '../../types';

export const getTimeTrackingOptions = (state: State): TimeTrackingOptions =>
	state.entities.timeTrackingOptions;
